<template>
  <div>
    <div class="case-pice">
      <span class="case-pice-first">发票申请记录</span>
      <span class="case-pice-and">/</span>
      <span class="case-pice-second">首页</span>
    </div>
    <div style="display: flex">
      <div class="commom-input-label-short">学员姓名：</div>
      <div class="common-full-width-style">
        <el-input
          v-model="searchData.name"
          clearable
          class="common-full-width"
          size="small"
          placeholder="请输入学员姓名"
        ></el-input>
      </div>
      <div class="commom-input-label-short">学员编号：</div>
      <div class="common-full-width-style">
        <el-input
          v-model="searchData.certificationNo"
          clearable
          class="common-full-width"
          size="small"
          placeholder="请输入学员编号"
        ></el-input>
      </div>
      <div class="commom-input-label-short">收货电话：</div>
      <div class="common-full-width-style">
        <el-input
          v-model="searchData.receiverPhone"
          clearable
          class="common-full-width"
          size="small"
          placeholder="请输入收货电话"
        ></el-input>
      </div>
      <div class="commom-input-label-short">快递单号：</div>
      <div class="common-full-width-style">
        <el-input
          v-model="searchData.expressNum"
          clearable
          class="common-full-width"
          size="small"
          placeholder="请输入快递单号"
        ></el-input>
      </div>
      <div class="commom-input-label-short">培训类别：</div>
      <div class="common-full-width-style">
        <el-select
          size="small"
          class="common-full-width"
          clearable
          v-model="searchData.trainingClasses"
          placeholder="请选择"
        >
          <el-option
            v-for="item in tarinTypeList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
    </div>
    <div style="display: flex">
      <div class="commom-input-label-short">专业类别：</div>
      <div class="common-full-width-style">
        <el-select
          size="small"
          class="common-full-width"
          v-model="searchData.professionalClasses"
          clearable
          placeholder="请选择"
        >
          <el-option
            v-for="(item, index) in majorCategoryList"
            :key="index"
            :label="item.codeCname"
            :value="item.codeCode"
          >
          </el-option>
        </el-select>
      </div>
      <div class="commom-input-label-short">会员单位：</div>
      <div class="common-full-width-style">
        <!--<el-select size='small' class='common-full-width' filterable v-model="searchData.companyName" clearable placeholder="请选择">
					<el-option v-for="(item,index) in companyListData" :key="index" :label="item.companyName" :value="item.companyName">
					</el-option>
				</el-select>-->
        <el-input
          v-model="searchData.companyName"
          clearable
          class="common-full-width"
          size="small"
          placeholder="请输入会员单位"
        ></el-input>
      </div>
      <div class="commom-input-label-short">是否开票：</div>
      <div class="common-full-width-style">
        <el-select
          size="small"
          class="common-full-width"
          filterable
          v-model="searchData.type"
          clearable
          placeholder="请选择"
        >
          <el-option
            v-for="(item, index) in isOpenBill"
            :key="index"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <div class="commom-input-label-short">开票公司名称：</div>
      <div class="common-full-width-style">
        <el-input
          v-model="searchData.invoiceCompanyName"
          clearable
          class="common-full-width"
          size="small"
          placeholder="请输入开票公司名称"
        ></el-input>
      </div>
      <div class="common-full-width-style"></div>
      <div class="commom-input-label-short" style="text-align: right">
        <el-button
          size="small"
          style="width: 88px; margin-right: 20px"
          type="primary"
          @click="search()"
          plain
          icon="el-icon-search"
          >查询</el-button
        >
      </div>
    </div>
    <el-table
      :data="tableData"
      border
      style="width: 100%"
      stripe
      height=" calc(100vh - 270px)"
    >
      <el-table-column label="序号" width="60">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column
        prop="applicationFormId"
        show-overflow-tooltip
        label="报名记录ID"
        min-width="200"
      >
      </el-table-column>
      <el-table-column
        prop="certificationNo"
        show-overflow-tooltip
        label="学员编号"
        min-width="150"
      >
      </el-table-column>
      <el-table-column
        prop="name"
        show-overflow-tooltip
        label="学员姓名"
        min-width="100"
      >
      </el-table-column>
      <el-table-column
        prop="phone"
        show-overflow-tooltip
        label="手机号码"
        min-width="150"
      >
      </el-table-column>
      <el-table-column
        prop="trainingClasses"
        show-overflow-tooltip
        label="培训类别"
        min-width="100"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.trainingClasses == 1">初次培训</span>
          <span v-if="scope.row.trainingClasses == 2">继续教育</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="professionalClasses"
        show-overflow-tooltip
        label="专业类别"
        min-width="150"
      ></el-table-column>
      <el-table-column show-overflow-tooltip label="审核状态" min-width="100">
        <template slot-scope="scope">
          <span v-if="scope.row.applicationStatus == 0">已取消</span>
          <span v-if="scope.row.applicationStatus == 1">未审核</span>
          <span v-if="scope.row.applicationStatus == 2">审核通过</span>
          <span v-if="scope.row.applicationStatus == 3">审核驳回</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="feeNum"
        show-overflow-tooltip
        label="金额"
        min-width="100"
      ></el-table-column>
      <el-table-column
        prop="applicationDate"
        show-overflow-tooltip
        label="报名时间"
        min-width="200"
      >
      </el-table-column>
      <!--<el-table-column prop="applicationDate" show-overflow-tooltip label="开票状态" min-width="120">
			</el-table-column>-->
      <!-- <el-table-column prop="receiverName" show-overflow-tooltip label="收货人" min-width="120">
			</el-table-column> -->
      <!-- <el-table-column prop="receiverPhone" show-overflow-tooltip label="收货电话" min-width="120">
			</el-table-column> -->
      <!-- <el-table-column prop="receiverAddress" show-overflow-tooltip label="收货地址" min-width="250">
			</el-table-column> -->
      <!-- <el-table-column show-overflow-tooltip label="收货信息" min-width="350">
				<template slot-scope="scope">
					{{scope.row.receiverName}}-{{scope.row.receiverPhone}}-{{scope.row.receiverAddress}}
				</template>
			</el-table-column> -->
      <el-table-column
        prop="companyName"
        show-overflow-tooltip
        label="会员单位"
        min-width="250"
      ></el-table-column>
      <!-- <el-table-column prop="express" show-overflow-tooltip label="物流平台" min-width="120">
			</el-table-column>
			<el-table-column prop="expressNum" show-overflow-tooltip label="快递单号" min-width="120">
			</el-table-column> -->
      <el-table-column
        prop="invoiceCompanyName"
        show-overflow-tooltip
        label="开票公司"
        min-width="120"
      >
      </el-table-column>
      <el-table-column
        prop="taxNo"
        show-overflow-tooltip
        label="公司税号"
        min-width="120"
      >
      </el-table-column>

      <el-table-column
        prop="remark"
        show-overflow-tooltip
        label="备注"
        min-width="120"
      >
      </el-table-column>

      <el-table-column
        prop="mail"
        show-overflow-tooltip
        label="收件邮箱"
        min-width="120"
      >
      </el-table-column>
      <el-table-column
        prop="bankNo"
        show-overflow-tooltip
        label="开户行账号"
        min-width="120"
      >
      </el-table-column>
      <el-table-column
        prop="bank"
        show-overflow-tooltip
        label="开户行"
        min-width="120"
      >
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="250">
        <template slot-scope="scope">
          <!-- 填写单号 -->
          <el-button
            size="mini"
            type="primary"
            @click="writeBill(scope.row)" v-if="scope.row.type==2"
            plain
            >开发票</el-button
          >
          <el-button
            size="mini"
            type="warning"v-else
            plain
            disabled
            >已开票</el-button
          >
          <el-button size="mini" type="info" @click="lookBill(scope.row)" plain
            >查看</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-block">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNumber"
      >
      </el-pagination>
    </div>
    <el-dialog
      title="填写单号"
      :visible.sync="dialogBillVisible"
      v-if="dialogBillVisible"
      width="40%"
    >
      <div style="display: flex; height: 50px; line-height: 50px">
        <div class="bill-left-block">物流平台：</div>
        <div style="flex: 1">
          <el-input
            v-model="billInfo.express"
            clearable
            class="common-full-width"
            size="small"
            placeholder="请输入物流平台"
          ></el-input>
        </div>
      </div>
      <div style="display: flex; height: 50px; line-height: 50px">
        <div class="bill-left-block">快递单号：</div>
        <div style="flex: 1">
          <el-input
            v-model="billInfo.expressNum"
            clearable
            class="common-full-width"
            size="small"
            placeholder="请输入快递单号"
          ></el-input>
        </div>
      </div>
      <div style="text-align: center; height: 50px; line-height: 50px">
        <el-button size="small" type="primary" @click="logisticeSave()" plain
          >保存</el-button
        >
        <el-button
          size="small"
          type="info"
          @click="dialogBillVisible = false"
          plain
          >取消</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      title="发票信息"
      :visible.sync="dialogDetailVisible"
      v-if="dialogDetailVisible"
      width="60%"
    >
      <div style="display: flex; height: 50px; line-height: 50px">
        <div class="bill-left-block">抬头类型：</div>
        <div style="flex: 1">
          {{ billDetail.invoiceTitle }}
        </div>
        <div class="bill-left-block">公司名称：</div>
        <div style="flex: 1">
          {{ billDetail.companyName }}
        </div>
      </div>
      <div style="display: flex; height: 50px; line-height: 50px">
        <div class="bill-left-block">公司税号：</div>
        <div style="flex: 1">
          {{ billDetail.taxNo }}
        </div>
        <div class="bill-left-block">公司电话：</div>
        <div style="flex: 1">
          {{ billDetail.phone }}
        </div>
      </div>
      <div style="display: flex; height: 50px; line-height: 50px">
        <div class="bill-left-block">开户行账号：</div>
        <div style="flex: 1">
          {{ billDetail.bankNo }}
        </div>
        <div class="bill-left-block">公司开户行：</div>
        <div style="flex: 1">
          {{ billDetail.bank }}
        </div>
      </div>
      <div style="display: flex; height: 50px; line-height: 50px">
        <div class="bill-left-block">公司地址：</div>
        <div style="flex: 1">
          {{ billDetail.address }}
        </div>
      </div>
      <div style="display: flex; height: 50px; line-height: 50px">
        <div class="bill-left-block">备注：</div>
        <div style="flex: 1">
          {{ billDetail.remark }}
        </div>
      </div>
    </el-dialog>
    <!-- 上传pdf 发票 -->
    <el-dialog
      title="上传发票信息"
      :visible.sync="dialogVisible"
      width="30%"
      center
      :before-close="handleClose"
      class="upload-dialog"
    >
      <el-form ref="form" :model="uploadData" label-width="80px">
        <el-form-item label="开票状态">
          <span>
            <label style="color: red; margin-right: 5px">未开票</label>
            <label style="color: darkgray">保存后系统更新开票状态</label>
          </span>
        </el-form-item>
        <el-form-item label="上传发票">
          <el-upload
            :headers="$util.getUploadHeaders()"
            :before-upload="beforeAvatarUpload"
            :on-success="handleFrontSuccess"
            :action="actionUrl"
            :show-file-list="false"
          >
            <span>
              <span  style="height: 20px; border:  1px solid darkgray; padding-left: 10px; padding-right: 10px; padding-top: 1px; padding-bottom: 1px; border-radius: 5px; font-size: 10px; background-color: rgba(128, 128, 128, 0.1); ">{{uploadData.url?'已上传':'选择文件'}} </span>
              <label style="margin-left: 8px; font-size: 10px;" v-if="!uploadData.url">未选择任何文件</label>
            </span>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="logisticeSave()"
          >保 存</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  applicationFormList,
  examOrBack,
  majorTypeList,
  getBillList,
  getBillDetail,
  fillBill,
  companyList,
} from "../../api/main";
export default {
  data() {
    return {
      billInfo: {
        express: "",
        expressNum: "",
      },
      dialogBillVisible: false,
      dialogVisible: false, //上传发票弹窗
      dialogDetailVisible: false,
      searchData: {
        name: "",
        certificationNo: "",
        receiverPhone: "",
        expressNum: "",
        trainingClasses: "",
        professionalClasses: "",
        companyName: "",
        invoiceStatus: "",
        invoiceCompanyName: "",
        type:0
      },
      options: [
        {
          label: "未更正",
          value: "未更正",
        },
        {
          label: "已更正",
          value: "已更正",
        },
      ],
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      totalNumber: 0,
      safetyList: [
        {
          label: "全部",
          value: "",
        },
        {
          label: "是",
          value: "1",
        },
        {
          label: "否",
          value: "0",
        },
      ],
      tarinTypeList: [
        {
          label: "全部",
          value: "",
        },
        {
          label: "初次培训",
          value: "1",
        },
        {
          label: "继续教育",
          value: "2",
        },
      ],
      majorCategoryList: [],
      trainersList: [
        {
          label: "全部",
          value: "",
        },
        {
          label: "负责人",
          value: "1",
        },
        {
          label: "安全管理人员",
          value: "0",
        },
         {
					label: '动态监控',
					value: "3"
				}, {
					label: '其他',
					value: "4"
				}
      ],
      stateList: [
        {
          label: "全部",
          value: "",
        },
        {
          label: "未审核",
          value: "1",
        },
        {
          label: "已取消",
          value: "0",
        },
        {
          label: "审核通过",
          value: "2",
        },
        {
          label: "审核驳回",
          value: "3",
        },
      ],
      billDetail: {},
      nowSelectData: {},
      companyListData: [],
      isOpenBill: [
        { label: "全部", value: 0 },
        { label: "是", value: 1 },
        { label: "否", value: 2 },
      ],
      actionUrl: "",
      uploadData: {}, // 上传发票
    };
  },
  mounted() {
    this.actionUrl = `${this.$httpUrl}/api/v1/uploadMaterial`;
    this.getSignUpList();
    this.getMajorDataList();
    this.getCompanyList();
  },
  methods: {
    getCompanyList() {
      companyList({
        current: 1,
        pageSize: 1000,
      }).then((res) => {
        this.companyListData = res.data.records;
      });
    },
    logisticeSave() {
      if(!this.uploadData.url){
        this.$message.error('请先上传发票')
        return
      }
      fillBill({
        url:this.uploadData.url,
        applicationFormId: this.nowSelectData.applicationFormId,
        type:1,
        orderId:this.nowSelectData.orderId
        // express: this.billInfo.express,
        // expressNum: this.billInfo.expressNum,
      }).then((res) => {
        if (res.code == 1) {
          this.search();
          this.dialogVisible = false;
          this.$message.success("上传成功");
          this.uploadData.url = "";
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    lookBill(item) {
      this.dialogDetailVisible = true;
      getBillDetail(item.applicationFormId).then((res) => {
        this.billDetail = res.data;
      });
    },
    exportTable() {
      this.tableData.forEach((item, index) => {
        if (item.sex == 0) {
          item.sexName = "男";
        }
        if (item.sex == 1) {
          item.sexName = "女";
        }
        if (item.education == 1) {
          item.educationName = "初中及以下";
        }
        if (item.education == 2) {
          item.educationName = "高中/中专";
        }
        if (item.education == 3) {
          item.educationName = "大专";
        }
        if (item.education == 4) {
          item.educationName = "本科";
        }
        if (item.education == 5) {
          item.educationName = "研究生";
        }
        if (item.education == 6) {
          item.educationName = "博士";
        }
        if (item.trainers == "1") {
          item.trainersName = "负责人";
        }
        if (item.education == 2) {
          item.trainersName = "安全管理人员";
        }
        if (item.trainingClasses == "1") {
          item.trainingClassesName = "初次培训";
        }
        if (item.trainingClasses == 2) {
          item.trainingClassesName = "继续教育";
        }
        if (item.applicationStatus == "0") {
          item.trainingStatusName = "已取消";
        }
        if (item.applicationStatus == 1) {
          item.trainingStatusName = "未审核";
        }
        if (item.applicationStatus == 2) {
          item.trainingStatusName = "审核通过";
        }
        if (item.applicationStatus == 3) {
          item.trainingStatusName = "审核驳回";
        }
        if (item.safetyStatus == 1) {
          item.safetyStatusName = "是";
        }
        if (item.safetyStatus == 0) {
          item.safetyStatusName = "否";
        }
      });
      require.ensure([], () => {
        const { export_json_to_excel } = require("@/common/js/Export2Excel");
        const tHeader = [
          "学员名称",
          "学员编号",
          "性别",
          "学历",
          "手机号码",
          "培训类别",
          "专业类别",
          "培训人员",
          "会员单位",
          "状态",
          "是否拥有安全证书",
          "报名日期",
        ];
        // 上面设置Excel的表格第一行的标题
        const filterVal = [
          "name",
          "certificationNo",
          "sexName",
          "educationName",
          "phone",
          "trainingClassesName",
          "professionalClasses",
          "trainersName",
          "companyName",
          "trainingStatusName",
          "safetyStatusName",
          "applicationDate",
        ];
        // 上面的 goodsName、goodsId、是exportData里对象的属性
        const list = this.tableData; //把data里的exportData存到list
        const data = this.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, "学员信息");
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    getMajorDataList() {
      majorTypeList({
        current: 1,
        pageSize: 30,
        professionalName: "",
      }).then((res) => {
        this.majorCategoryList = res.data.records;
        this.majorCategoryList.unshift({
          codeCname: "全部",
          codeCode: "",
        });
      });
    },
    getSignUpList() {
      getBillList({
        name: this.searchData.name,
        certificationNo: this.searchData.certificationNo,
        receiverPhone: this.searchData.receiverPhone,
        expressNum: this.searchData.expressNum,
        trainingClasses: this.searchData.trainingClasses,
        professionalClasses: this.searchData.professionalClasses,
        pageSize: this.pageSize,
        current: this.currentPage,
        companyName: this.searchData.companyName,
        invoiceStatus: this.searchData.invoiceStatus,
        invoiceCompanyName: this.searchData.invoiceCompanyName,
        type:this.searchData.type
      }).then((res) => {
        this.tableData = res.data.records;
        this.totalNumber = parseInt(res.data.total);
      });
    },
    search() {
      this.currentPage = 1;
      this.getSignUpList();
    },
    handleSizeChange(data) {
      this.pageSize = data;
      this.getSignUpList();
    },
    handleCurrentChange(data) {
      this.currentPage = data;
      this.getSignUpList();
    },
    writeBill(item) {
      // 填写单号
      this.nowSelectData = item;
      // this.billInfo.express = item.express;
      // this.billInfo.expressNum = item.expressNum;
      // this.dialogBillVisible = true;
      // 开发票
      this.dialogVisible = true;
    },
    // 关闭上传图片弹窗
    handleClose() {
      this.dialogVisible = false;
    },
    // 上传图片相关
    beforeAvatarUpload(file) {
      let isJPG = file.type;
      let isLt2M = file.size / 1024 / 1024 < 0.2;
      if (
        file.type == "application/pdf"
      ) {
        isJPG = true;
      } else {
        this.$message.error("只能上传pdf文件格式");
        isJPG = false;
      }
      if (isJPG) {
        return true;
      } else {
        return false;
      }
    },
    handleFrontSuccess(res, file) {
      this.$forceUpdate();
      this.uploadData.url = res.data;
    },
  },
};
</script>

<style lang="less">
.bill-left-block {
  width: 100px;
  text-align: right;
}
.upload-dialog {
  .el-dialog__header {
    .center-title .el-dialog__title {
      text-align: center;
      font-size: 18px;
      font-weight: bold;
    }
    background: white;
    .el-dialog__title {
      color: black;
    }
    .el-dialog__headerbtn .el-dialog__close {
      color: black;
    }
  }
}
</style>